export const TEMPLATE_HELP_CODE = {
  PYTHON: `from promptlayer import PromptLayer

promptlayer_client = PromptLayer(api_key="your_api_key")

response = promptlayer_client.run(
    prompt_name="my-prompt",
    input_variables={"topic": "poetry"},
    tags=["getting-started"],
    metadata={"user_id": "123"}
)

print(response["request_id"])`,
  JAVASCRIPT: `import { PromptLayer } from "promptlayer";

const promptLayerClient = new PromptLayer({ apiKey: "your_api_key" });

const response = await promptLayerClient.run({
  promptName: "my-prompt",
  inputVariables: { topic: "poetry" },
  tags: ["getting-started"],
  metadata: { user_id: "123" },
});

console.log(response.request_id);`,
} as const;
